<template>
  <fragment>
    <div class="col-12 col-sm-auto mb-1 mb-sm-0 order-sm-1 fs-6 fw-bold text-red d-inline-block">
      <!-- {{title}} -->
      <slot title="title"></slot>
      &nbsp;
    </div>
    <div class="col-12 col-md-auto mt-sm-3 mt-md-0 order-sm-3 order-md-2 text-secondary">
      -
      {{desc}}
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: [
		"desc",
	],
  components: {
  },
  data() {
    return {
      title: "",
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
